export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.civista.co.uk',
  ENDPOINTS: {
    // Authentication
    AUTH: {
      REGISTER: '/api/auth/register',
      LOGIN: '/api/auth/login',
      LOGOUT: '/api/auth/logout',
      PROFILE: '/api/auth/profile',
      VERIFY_EMAIL: '/api/auth/verify-email',
      RESET_PASSWORD: '/api/auth/reset-password',
      CHANGE_PASSWORD: '/api/auth/change-password',
      MFA: {
        SETUP: '/api/auth/mfa/setup',
        DISABLE: '/api/auth/mfa/disable',
      },
    },
    // Benefits
    BENEFITS: {
      TYPES: '/api/benefits/types',
      TYPE_DETAIL: (id: string) => `/api/benefits/types/${id}`,
      CALCULATE: '/api/benefits/calculate',
      SCENARIOS: '/api/benefits/scenarios',
      SCENARIO_DETAIL: (id: string) => `/api/benefits/scenarios/${id}`,
      HISTORY: '/api/benefits/history',
    },
    // AI Chat
    AI: {
      MODELS: '/api/ai/models',
      CONVERSATIONS: '/api/ai/conversations',
      CONVERSATION_DETAIL: (id: string) => `/api/ai/conversations/${id}`,
      MESSAGES: (id: string) => `/api/ai/conversations/${id}/messages`,
      MESSAGE_FEEDBACK: (id: string) => `/api/ai/messages/${id}/feedback`,
    },
    // AutoRAG
    AUTORAG: {
      COLLECTIONS: '/api/autorag/collections',
      COLLECTION_DETAIL: (id: string) => `/api/autorag/collections/${id}`,
      COLLECTION_FILES: (id: string) => `/api/autorag/collections/${id}/files`,
      FILES: '/api/autorag/files',
      FILE_DETAIL: (id: string) => `/api/autorag/files/${id}`,
      SEARCH: '/api/autorag/search',
    },
    // Jobs
    JOBS: {
      LIST: '/api/jobs',
      DETAIL: (id: string) => `/api/jobs/${id}`,
      RETRY: (id: string) => `/api/jobs/${id}/retry`,
      CANCEL: (id: string) => `/api/jobs/${id}/cancel`,
      TYPES: '/api/jobs/types',
      METRICS: '/api/jobs/metrics',
    },
    // Admin
    ADMIN: {
      DASHBOARD: '/api/admin/dashboard',
      USERS: '/api/admin/users',
      USER_DETAIL: (id: string) => `/api/admin/users/${id}`,
      SETTINGS: '/api/admin/settings',
      SETTING_CATEGORY: (category: string) => `/api/admin/settings/${category}`,
      SETTING_DETAIL: (category: string, key: string) => `/api/admin/settings/${category}/${key}`,
      SECURITY: {
        EVENTS: '/api/admin/security/events',
        ALERTS: '/api/admin/security/alerts',
      },
      HEALTH: '/api/admin/health',
      AUDIT_LOGS: '/api/admin/audit-logs',
      METRICS: '/api/admin/metrics',
      ROLES: '/api/admin/roles',
    },
    // Root
    ROOT: '/',
    API_INFO: '/api',
    DEBUG_DB: '/debug/db',
  },
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;

export const RATE_LIMITS = {
  DEFAULT: {
    REQUESTS: 100,
    WINDOW: 60000, // 1 minute
  },
  PASSWORD_RESET: {
    REQUESTS: 3,
    WINDOW: 3600000, // 1 hour
  },
} as const;